import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const InspirationPopup = ({ box, onYes, onNo, onClose }) => {
  if (!box) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="popup-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="popup-sheet"
          initial={{ y: '100%' }}
          animate={{ y: 0 }}
          exit={{ y: '100%' }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          onClick={e => e.stopPropagation()}
        >
          <div className="popup-handle" />

          <div className="popup-box-emoji">{box.emoji}</div>
          <div className="popup-box-name">{box.name}</div>
          <div className="popup-question">
            {box.question}
          </div>

          <div className="popup-btn-row">
            <button className="popup-btn no" onClick={onNo}>
              No
            </button>
            <button className="popup-btn yes" onClick={onYes}>
              Yes!
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default InspirationPopup;
